import HeroCarousel from './components/hero-carousel';
import createHowItWorksCarousel from './components/hiw-carousel';
import createProductFeatures from './components/product-features';
import Accordion from './components/Accordion';
import { trackEvent } from 'common/utils/analytics';
import ScrollToElement from './components/ScrollToElement';
import ServiceDesignerFilter from './components/ServiceDesignerFilter';

document.addEventListener('DOMContentLoaded', () => {
    // Hero carousel
    HeroCarousel.create().start();

    // How it works
    createHowItWorksCarousel(document.querySelector('[data-hiw]'));

    // Product features
    createProductFeatures();

    // FAQs
    Accordion.create();

    // Scroll to service designers link
    for (const element of document.querySelectorAll('[data-service-designers-link]')) {
        new ScrollToElement(element).handleClick();
    }

    // Track FAQ usage to Segment
    for (const faq of document.querySelectorAll('#faqs [data-accordion-item-trigger]')) {
        faq.addEventListener('click', (e) => trackEvent('Clicked FAQ on Service Page', {
            title: faq.textContent.trim(),
        }));
    }

    ServiceDesignerFilter.create();
});



// WEBPACK FOOTER //
// ./js/marketing/service.js